import script from "./Natuursteenshoppage.vue?vue&type=script&setup=true&lang=js"
export * from "./Natuursteenshoppage.vue?vue&type=script&setup=true&lang=js"

import "./Natuursteenshoppage.vue?vue&type=style&index=0&id=6245c3f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6245c3f4"]])

export default __exports__